module.exports = __webpack_public_path__ + "img/decor3.0aa1b044.svg";